<template>
  <Modal v-model="model" :header="false" :footer="false">
    <div class="text-center">
      <h1>Congratulations!</h1>
      <p class="subtitle">You’ve successfully created the team</p>
      <h2 data-test="new-team-name">{{ props.team.name }}</h2>
      <div class="team-image-container image-margin">
        <img :src="props.team.imageUrl" alt="team image" data-test="new-team-img" />
      </div>
      <p class="mb-0">Now that you’ve created a team, it’s time to level up!</p>
      <p>Click the button below and you will be directed to the ‘Team Lead area’.</p>

      <a
        :href="goButtonLink"
        class="btn btn-primary-forward btn-center"
        data-test="new-team-invite-link"
        ref="modalLink"
        tabindex="0"
        >Go</a
      >
    </div>
  </Modal>
</template>
<script setup lang="ts">
import { Modal } from "uiv";
import { computed, nextTick, onMounted, ref } from "vue";
import { TeamApiModel } from "../../api-models";

const props = defineProps<{ team: TeamApiModel }>();
const model = defineModel();

const modalLink = ref<HTMLAnchorElement>();

const goButtonLink = computed(() => {
  return `${window.location.origin}/home?view=TeamLeadArea&team=${props.team.id}`;
});

onMounted(() => {
  if (modalLink.value) {
    nextTick(() => {
      modalLink.value?.focus();
      modalLink.value?.blur();
    });
  }
});
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables.less";

h1 {
  margin-bottom: 0;
}

.subtitle {
  color: @form-text-color;
}

.mb-0 {
  margin-bottom: 0;
}

p:not(.subtitle) {
  color: @off-black;
}

.btn.btn-center {
  margin: 1rem auto 0;
}

.image-margin {
  margin: 20px auto;
}
</style>
